import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';
import {MatButtonModule} from "@angular/material/button";
import {RouterModule} from "@angular/router";
import {NavFilterPipeModule} from "@app/pipes/nav-filter/nav-filter-pipe.module";



@NgModule({
  declarations: [HeaderComponent],
  exports: [
    HeaderComponent
  ],
    imports: [
        CommonModule,
        MatButtonModule,
        NavFilterPipeModule,
        RouterModule
    ]
})
export class HeaderModule { }
